export function getTailwindValue(value: string) {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return "" // Or throw an error, depending on your needs
  }
  const theme = getComputedStyle(document.documentElement)
  const returnvalue = theme.getPropertyValue(value)
  if ((returnvalue ?? "") === "") {
    console.info(`color "${value}" not found`)
  }
  return returnvalue
}
